module.exports = __webpack_public_path__ + "img/68_29.db6de00d.png";